"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerFollowingToAddInfos = void 0;
var max_1 = require("../constants/max.js");
/**
 *
 * @param {number} following : number immediately following the header
 * usually the payload length, or the number itself for uints and negInts
 *
 * @returns {number} a 5 bit unsigned integer that best represents the number of bytes
 */
function headerFollowingToAddInfos(following) {
    if (following < 0)
        return headerFollowingToAddInfos(-following);
    if (following > max_1.MAX_4_BYTES)
        return 27;
    if (following < 24)
        return Number(following);
    if (following < max_1.OVERFLOW_1_BYTE)
        return 24;
    if (following < max_1.OVERFLOW_2_BYTES)
        return 25;
    if (following < max_1.OVERFLOW_4_BYTES)
        return 26;
    return 27;
}
exports.headerFollowingToAddInfos = headerFollowingToAddInfos;
